import React from 'react';
import { plum, white } from '../utils/constants';
var muiInsightsIcon = {
    paths: [
        {
            path: 'M22,-0.5 L2,-0.5 C1.30964406,-0.5 0.684644063,-0.220177969 0.232233047,0.232233047 C-0.220177969,0.684644063 -0.5,1.30964406 -0.5,2 L-0.49996137,21.9999621 C-0.495660948,22.6934114 -0.211959763,23.3166601 0.243254382,23.7662505 C0.698468526,24.215841 1.32519563,24.491773 2.01553823,24.4874823 L22.0155382,24.363174 C22.7028488,24.3589021 23.3239642,24.0775761 23.773252,23.6254871 C24.2225398,23.1733981 24.5,22.5505461 24.5,21.8632223 L24.5,18.4584259 L31.3343635,12.5 L24.5,12.5 L24.5,2 C24.5,1.30964406 24.220178,0.684644063 23.767767,0.232233047 C23.3153559,-0.220177969 22.6903559,-0.5 22,-0.5 Z',
            fill: white,
            stroke: '#D6D6D6',
        },
        {
            path: 'M9.28754404,4.15416226 C4.88309019,5.08644635 1.41818895,10.1599267 3.74803634,15.4473192 C5.1509441,18.4275905 8.06970315,19.89057 10.1343339,20 C10.9553244,19.1028118 13.5249332,16.3611923 14.3790615,15.4323603 C10.9299838,15.4323603 10.2131077,15.5196972 9.46045657,15.1077524 C6.82262307,13.6645646 6.78524277,9.86282012 9.94926702,8.71581841 C11.778379,8.14277783 14.4027968,9.2760864 14.4027968,12.2685549 C14.4027968,13.3561813 14.4299721,12.2486481 14.3858266,15.4323603 L14.3858266,19.6878195 L19,19.6878195 L19,11.8911306 C19,7.52313456 14.9646479,3.11359882 9.28754404,4.15416226',
            fill: plum,
        },
    ],
    pathsWrapper: function (_a) {
        var children = _a.children;
        return (React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", transform: "translate(1.0, 1.0)" }, children));
    },
    title: 'Ally Insights',
    width: 32,
    height: 24,
};
var muiInsights = {
    base: muiInsightsIcon,
};
export { muiInsights };
//# sourceMappingURL=insights.js.map